import script from "./ChartPagePickerDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChartPagePickerDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ChartPagePickerDialog.vue?vue&type=style&index=0&id=70fb1d64&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70fb1d64"]])

export default __exports__